/** One `assignPypeConnection` call: the invoke detaches at most one connection. */
export interface AssignmentStep {
  fromConnectionId?: string;
  toConnectionId?: string;
}

/**
 * Turns "detach these, attach that" into the calls the invoke can take: one per
 * detached connection, with the new connection on the LAST call only, so a
 * channel is never attached to two connections at once. Nothing to detach and
 * nothing to attach is no call at all.
 */
export const planAssignmentSteps = (
  fromConnectionIds: string[],
  toConnectionId: string | undefined
): AssignmentStep[] => {
  if (fromConnectionIds.length === 0) {
    return toConnectionId ? [{ toConnectionId }] : [];
  }

  return fromConnectionIds.map((fromConnectionId, index) =>
    toConnectionId && index === fromConnectionIds.length - 1
      ? { fromConnectionId, toConnectionId }
      : { fromConnectionId }
  );
};
